//import { GoogleMap } from "../../components/GoogleMap/GoogleMap";
import GoogleMapsComponent from "../../components/GoogleMapsComponent/GoogleMapsComponent";
import { Wrapper } from "@googlemaps/react-wrapper";
import { useRef, useCallback, useState, useEffect, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { ProgressSpinner } from "primereact/progressspinner";
import { useLoaderData, Await } from "react-router-dom";
import { BlockUI } from "primereact/blockui";
//import Marker from "../../components/GoogleMap/Marker";


const FarmsMap = ({farms, hidden}) => {
    const ref = useRef(null);
    const deferData = useLoaderData();
    const { t, i18n } = useTranslation();
    const getInfoWindow = useCallback(
        (data) => {
            const decimals = 2;
            const infoWindow =`
            <div style="color:black">
                <div>
                    <p><b>${t("infoWindow.farm")}: </b> ${data.name === null || data.name === "" ? t("infoWindow.notConfigured") : data.name }</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.accountName")}: </b> ${data.account_name === null || data.account_name === "" ? t("infoWindow.notConfigured") : data.account_name }</p>
                </div>
                <br>
                <div>
                <p><b>${t("infoWindow.integrator")}: </b> ${data.dist.join(", ")}</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.crops")}: </b> ${data.crops.join(", ")} </p>
                </div>
                <div>
                <p><b>${t("infoWindow.area")}: </b> ${data.superficie.toFixed(decimals)} ${data.unidad}</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.accountManager")}: </b> ${data.account_manager === null || data.account_manager === "" ? t("infoWindow.notConfigured") : data.account_manager }</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.nodes")}: </b> ${data.nodes}</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.costCenter")}: </b> ${data.centro_costo === null ? "" : data.centro_costo}</p>
                </div>
                <div>
                    <p><b>${t("infoWindow.links")}: </b><a href="https://www.dropcontrol.com/site/dashboard/campo.do?cuentaId=${data.account_id}&campoId=${data.farm_id}" target="_blank"> ${t("infoWindow.dropControl")} </a>,
                    <a href="https://setup.wiseconn.com/awi/management.jsf?ca=${data.farm_id}&page=campo" target="_blank"> ${t("infoWindow.setUp")} </a>, <a href="https://admin.dropcontrol.com/farms?farm=${data.farm_id}" target="_blank"> ${t("infoWindow.admin")} </a></p>
                </div>
            </div>`;
            return { content: infoWindow };
        },
        [t, i18n.language]
    );

    const [isLoading, setIsLoading] = useState(false);

    return (
        <div>
            <BlockUI blocked={isLoading} template={<ProgressSpinner />}>
                <Wrapper apiKey="AIzaSyDk1GjYoG2sm9NeYANS9sXvpC5j0zhmqN0">
                    <GoogleMapsComponent
                        divId="gmap"
                        divRef={ref}
                        idKey="farm_id"
                        getInfoWindow={getInfoWindow}
                        markers={farms}
                        hidden={hidden}
                    />
                </Wrapper>
            </BlockUI>
            <Suspense fallback={<LoadingComponent setIsLoading={setIsLoading} />}>
                <Await resolve={deferData.farms} />
            </Suspense>
        </div>
    );
};

const LoadingComponent = ({setIsLoading}) => {
    useEffect(()=>{
        setIsLoading(true);
        return (()=>setIsLoading(false));
    },[]);
    return null;
};

export { FarmsMap };
